<div class="gridItemChildModule w-100 h-100 d-flex flex-column">
    <div id="CategoryOverTime-categories"> <!--This component should always be available-->
        {{getCategoryTitle()}}<svg *ngIf="canSelectCategory" class="icon-20 fill-iconDefault" style="margin-left: 10px;" (click)="showCategoryModal()"><use href="../App_Themes/CXone/icons/settings.svg#settings"></use></svg>
    </div>
    <app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
    <div id="CategoryOverTime-chart" class="mx-2" *ngIf="!noData">
        <div style="width: 42px; overflow: hidden; height: inherit; position: absolute; display: inline;">
            <canvas  baseChart *ngIf="chartConfig"
            [type]="chartConfig.type"
            [legend]="chartConfig.options.plugins.legend.display"
            [datasets]="chartConfig.data.datasets"
            [labels]="chartConfig.data.labels"
            [options]="chartConfig.options"
            [plugins]="chartConfig.plugins">
        </canvas>
        </div>
        <div id="CoTChartArea">
            <div class="chartScaler">
                <canvas baseChart *ngIf="chartConfig"
                    [type]="chartConfig.type"
                    [legend]="chartConfig.options.plugins.legend.display"
                    [datasets]="chartConfig.data.datasets"
                    [labels]="chartConfig.data.labels"
                    [options]="chartConfig.options"
                    [plugins]="chartConfig.plugins">
                </canvas>
            </div>
        </div>
    </div>
</div>
